import { Component, OnInit } from '@angular/core';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-top-stepper',
  templateUrl: './top-stepper.component.html',
  styleUrls: ['./top-stepper.component.scss']
})
export class TopStepperComponent implements OnInit {

  constructor(
    public au:AutoMlService
  ) { }

  ngOnInit() {
  }

  backOption(){
    if(this.au.isSatisfy){
      this.au.isSatisfy = false;
      this.au.stepperOptions[4].last =false;
      this.au.stepperOptions[4].step =false;
      this.au.stepperOptions[3].step =true;
      this.au.stepperOptions[3].last =true;

      if(this.au.iterationSet.length===1){
        this.au.stepperOptions[4].last =false;
        this.au.stepperOptions[4].step =false;
        this.au.stepperOptions[3].step =false;
        this.au.stepperOptions[3].last =false;
        this.au.stepperOptions[2].step =true;
        this.au.stepperOptions[2].last =true;
      }

    }
    else{
      location.reload();
    }
  }

}
